import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import LedgerDetail from '@app/views/Ledger/LedgerDetail';
import { memo } from 'react';

export default memo(
  withIfUser(LedgerDetail)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
